module.exports = __webpack_public_path__ + "static/media/gallery14.183f7e07.png";